var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheck = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73047 10.2812C6.00391 10.5547 6.46875 10.5547 6.74219 10.2812L14.7812 2.24219C15.0547 1.96875 15.0547 1.50391 14.7812 1.23047L13.7969 0.246094C13.5234 -0.0273438 13.0859 -0.0273438 12.8125 0.246094L6.25 6.80859L3.16016 3.74609C2.88672 3.47266 2.44922 3.47266 2.17578 3.74609L1.19141 4.73047C0.917969 5.00391 0.917969 5.46875 1.19141 5.74219L5.73047 10.2812Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/check.2f9a433f.svg";
export { ForwardRef as ReactComponent };